import {
  RequestAction,
  createEntityActionNames,
  createEntityActions,
  createRequestTypes,
} from "store/entities/actions";
import { ActionsUnion, createAction } from "store/helper";

import {
  ISyncDefaultTeamIdPayload,
  ISyncDeleteTeamPayload,
  ISyncDeletedAgentPayload,
  ISyncTeamAgentsPayload,
  ISyncUpdatedAgentPayload,
  ITeam,
  IUpdateNotificationsFailurePayload,
  IUpdateNotificationsPayload,
  IUpdateNotificationsSuccessPayload,
  IUpdateTagReminderToggleFailurePayload,
  IUpdateTagReminderTogglePayload,
  IUpdateTagReminderToggleSuccessPayload,
} from "./interfaces";

export const TeamActionsNames = {
  ...createEntityActionNames("TEAM"),
  UPDATE_NOTIFICATIONS: "ENTITIES/TEAM/UPDATE_NOTIFICATIONS",
  UPDATE_TAG_REMINDER_TOGGLE: "ENTITIES/TEAM/UPDATE_TAG_REMINDER_TOGGLE",
  SYNC_CREATED_AGENTS: "ENTITIES/TEAM/SYNC_CREATED_AGENTS",
  SYNC_UPDATED_AGENT: "ENTITIES/TEAM/SYNC_UPDATED_AGENT",
  SYNC_DELETED_AGENT: "ENTITIES/TEAM/SYNC_DELETED_AGENT",
  SYNC_AGENTS: "ENTITIES/TEAM/SYNC_AGENTS",
  SYNC_DELETE: "ENTITIES/TEAM/SYNC_DELETE",
  SYNC_DEFAULT_TEAM_ID: "ENTITIES/TEAM/SYNC_DEFAULT_TEAM_ID",
};

export const TEAM = {
  ...createEntityActionNames("TEAM"),
  UPDATE_NOTIFICATIONS: createRequestTypes(TeamActionsNames.UPDATE_NOTIFICATIONS),
  UPDATE_TAG_REMINDER_TOGGLE: createRequestTypes(TeamActionsNames.UPDATE_TAG_REMINDER_TOGGLE),
};

const createUpdateNotificationsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateNotifications: (payload: IUpdateNotificationsPayload) =>
    createAction(TEAM.UPDATE_NOTIFICATIONS[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateNotificationsSuccess: (payload: IUpdateNotificationsSuccessPayload) =>
    createAction(TEAM.UPDATE_NOTIFICATIONS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateNotificationsFailure: (payload: IUpdateNotificationsFailurePayload) =>
    createAction(TEAM.UPDATE_NOTIFICATIONS[RequestAction.FAILURE], payload),
};

export const TeamActions = {
  ...createEntityActions<ITeam>(TEAM),
  ...createUpdateNotificationsActions,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncCreatedAgents: (payload: ISyncTeamAgentsPayload) => createAction(TeamActionsNames.SYNC_CREATED_AGENTS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncUpdatedAgent: (payload: ISyncUpdatedAgentPayload) => createAction(TeamActionsNames.SYNC_UPDATED_AGENT, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDeletedAgent: (payload: ISyncDeletedAgentPayload) => createAction(TeamActionsNames.SYNC_DELETED_AGENT, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncAgents: (payload: ISyncTeamAgentsPayload) => createAction(TeamActionsNames.SYNC_AGENTS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteTeamPayload) => createAction(TeamActionsNames.SYNC_DELETE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDefaultTeamId: (payload: ISyncDefaultTeamIdPayload) =>
    createAction(TeamActionsNames.SYNC_DEFAULT_TEAM_ID, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateTagReminderToggle: (payload: IUpdateTagReminderTogglePayload) =>
    createAction(TEAM.UPDATE_TAG_REMINDER_TOGGLE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateTagReminderToggleSuccess: (payload: IUpdateTagReminderToggleSuccessPayload) =>
    createAction(TEAM.UPDATE_TAG_REMINDER_TOGGLE[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateTagReminderToggleFailure: (payload: IUpdateTagReminderToggleFailurePayload) =>
    createAction(TEAM.UPDATE_TAG_REMINDER_TOGGLE[RequestAction.FAILURE], payload),
};

export type TeamAction = ActionsUnion<typeof TeamActions>;
